import { Stack } from '@karma/components';
import styled from 'styled-components';

export const StyledTabs = styled(Stack)``;
